<template>
  <div class="login" v-show="!isRequestingPermission">
    <TitleBar :text="$t(`Login.${isRegisterMode ? 'createAccountTopic' : 'loginTopic'}`)" :enableIconButton="false" @clickCloseButton="clickCloseButton" v-show="!isShowingAllowNotiPermissionDialog && !isRegistingFcmToken" />
    <div class="body" v-show="!isShowingActivateOnEmailDialog && !isShowingAllowNotiPermissionDialog && !isRegistingFcmToken">
      <button class="alternative-login-button facebook" @click="facebookLogin">
        <img :src="util.getImagePath('facebook@2x.png')" :srcset="util.getImageSet('facebook')">
        <label>{{ isRegisterMode ? $t('Login.facebookRegister') : $t('Login.facebookLogin') }}</label>
      </button>
      <button class="alternative-login-button apple" @click="appleLogin" v-if="showAppleLogin">
        <img :src="util.getImagePath('apple@2x.png')" :srcset="util.getImageSet('apple')">
        <!-- <div id="appleid-signin" ref="appleid-signin" style="width: 24px; height: 24px;" data-mode="logo-only" data-color="black" data-border="false" data-border-radius="4" data-type="sign in"></div> -->
        <label>{{ isRegisterMode ? $t('Login.appleRegister') : $t('Login.appleLogin') }}</label>
      </button>
      <button class="alternative-login-button line" @click="lineLogin" v-if="showLineLogin">
        <img :src="util.getImagePath('line@2x.png')" :srcset="util.getImageSet('line')">
        <label>{{ isRegisterMode ? $t('Login.lineRegister') : $t('Login.lineLogin') }}</label>
      </button>
      <button class="alternative-login-button google" @click="googleLogin" v-show="false">
        <img :src="util.getImagePath('google@2x.png')" :srcset="util.getImageSet('google')">
        <label>{{ isRegisterMode ? $t('Login.googleRegister') : $t('Login.googleLogin') }}</label>
      </button>
      <div class="alternative-label">- {{ $t('Login.or') }} -</div>
      <div class="activated-notice" v-if="isActivatedMode">{{ $t('Login.activated') }}</div>
      <form>
        <input name="email" type="email" :placeholder="$t('Login.email')" v-model="email" v-show="isRegisterMode" @keypress.enter="submit">
        <input name="username" type="text" :placeholder="$t('Login.username')" v-model="username" v-show="!isRegisterMode" @keypress.enter="submit">
        <input name="password" type="password" :placeholder="$t('Login.password')" v-model="password" @keypress.enter="submit">
        <input name="confirm-password" type="password" :placeholder="$t('Login.confirmPassword')" v-model="confirmPassword" v-show="isRegisterMode" @keypress.enter="submit">
      </form>
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 16px;">
        <label class="pp-checkbox checkbox-transfer" v-show="(favoriteList || []).length > 0">
          {{ $t('Login.isTransfer') }}
          <input ref="checkboxTransfer" name="checkbox-transfer" type="checkbox">
          <span class="checkmark"></span>
        </label>
        <button class="forgot-password" @click="clickForgotPasswordButton" v-if="!isRegisterMode">{{ $t('Login.forgotPassword') }}</button>
      </div>
      <div class="login-alert" v-if="!isRegisterMode">{{ alertFromLogin }}</div>
      <div class="register-alert" v-if="isRegisterMode" v-html="alertFromRegister"></div>
      <button class="submit-btn" @click="submit">{{ $t(`Login.${isRegisterMode ? 'createAccountTopic' : 'loginTopic'}`) }}</button>
      <div class="goto-mode" :class="{shake: shakeRegisterButton}" @click="toggleIsRegisterMode">{{ $t(`Login.${isRegisterMode ? 'loginTopic' : 'createAccountTopic'}`) }}</div>
    </div>
    <div class="noti-permission-dialog" v-show="isShowingAllowNotiPermissionDialog && !isRegistingFcmToken">
      <div class="text">{{ $t('Login.notiPermissionDialog') }}</div>
      <div class="button-container">
        <button class="outline" @click="allowPermissionNotiDialogCallback(false)">{{ $t('Login.notAllow') }}</button>
        <button @click="allowPermissionNotiDialogCallback(true)">{{ $t('Login.allow') }}</button>
      </div>
    </div>
    <div class="activate-on-email-dialog" v-show="isShowingActivateOnEmailDialog">
      <div class="text">{{ messageOfActivateOnEmailDialog }}</div>
      <div class="button-container">
        <button class="submit-btn" @click="closeActivateOnEmailDialog">{{ $t('Login.close') }}</button>
      </div>
    </div>
    <div v-if="isRegistering" class="loading-animation-container">
      <div class="loading-animation primary"></div>
    </div>
    <div v-if="isLoggingIn && !isRegistingFcmToken" class="loading-animation-container">
      <div class="loading-animation primary"></div>
    </div>
    <div v-if="isRegistingFcmToken" class="loading-animation white"></div>
    <AcceptPdpa v-if="isRegisterMode && isShowAcceptPdpa" @cancel="isRegisterMode = false" @accept="isShowAcceptPdpa = false" />
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import AcceptPdpa from '@/components/AcceptPdpa.vue'

export default {
  name: 'Login',
  components: {
    TitleBar,
    AcceptPdpa
  },
  props: {
    initUsername: {
      type: String,
      default: ''
    },
    isActivatedMode: {
      type: Boolean,
      default: false
    },
    isTransfer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isRegisterMode: false,
      email: '',
      username: '',
      password: '',
      confirmPassword: '',
      alertFromLogin: '',
      alertFromRegister: '',
      isLoggingIn: false,
      isRegistering: false,
      isShowingActivateOnEmailDialog: false,
      isShowingAllowNotiPermissionDialog: false,
      allowPermissionNotiDialogCallback: undefined,
      isRequestingPermission: false,
      isRegistingFcmToken: false,
      messageOfActivateOnEmailDialog: '',
      iOSAppVersion: [0, 0, 0],
      isShowAcceptPdpa: false,
      shakeRegisterButton: false
    }
  },
  computed: {
    showLineLogin () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent !== 'Android application' && userAgent !== 'iOS application' && process.env.NODE_ENV !== 'development') {
        return false && !window.liff.isInClient() && !(userAgent.indexOf('application') !== -1)
      } else {
        return false && !(userAgent.indexOf('application') !== -1)
      }
    },
    showAppleLogin () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var iOSAppVersionCondition = true
      var iOSVersionCondition = true
      if (userAgent === 'iOS application') {
        if (self.iOSAppVersion[0] === 1) {
          if (self.iOSAppVersion[1] === 0) {
            if (self.iOSAppVersion[2] < 5) {
              iOSAppVersionCondition = false
            }
          } else if (self.iOSAppVersion[1] < 0) {
            iOSAppVersionCondition = false
          }
        } else if (self.iOSAppVersion[0] < 1) {
          iOSAppVersionCondition = false
        }
        const iOSVersion = self.util.iOSVersion()
        iOSVersionCondition = iOSVersion[0] >= 14 || self.util.isIpadOS()
      }
      return userAgent !== 'Android application' && !self.util.isAndroidDevice() && iOSAppVersionCondition && iOSVersionCondition
    }
  },
  mounted () {
    var self = this
    var userAgent = self.util.getUserAgentMeta()
    if (userAgent === 'iOS application') {
      window.receiveVersion = (version, build) => {
        self.iOSAppVersion = version.split('.').map(v => Number(v))
      }
      window.location.href = `https://native.getversion`
    }
    self.initApple(document, 'script', 'apple-jssdk')
    if (self.initUsername !== '') {
      self.username = self.initUsername
    }
    self.$refs['checkboxTransfer'].checked = self.isTransfer
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    clickForgotPasswordButton () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'ForgotPassword'
      })
    },
    toggleIsRegisterMode () {
      var self = this
      self.isRegisterMode = !self.isRegisterMode
      self.email = ''
      self.username = ''
      self.password = ''
    },
    validateRegister () {
      var self = this
      var isValid = true
      var style = 'style="color: rgb(220, 20, 60); padding: 0px 8px; text-align: left;"'
      self.alertFromRegister = '<ul style="margin: 0px auto 0px 0px; padding-left: 24px;">'
      if (self.email === '') {
        isValid = false
        self.alertFromRegister += `<li ${style}>${self.$t('Login.errorEmail')}</li>`
      }
      if (self.password === '') {
        isValid = false
        self.alertFromRegister += `<li ${style}>${self.$t('Login.errorPassword')}</li>`
      }
      if (self.password !== self.confirmPassword) {
        isValid = false
        self.alertFromRegister += `<li ${style}>${self.$t('Login.errorConfirmPassword')}</li>`
      }
      self.alertFromRegister += '</ul>'
      return isValid
    },
    submit () {
      var self = this
      if (self.isRegisterMode) {
        self.isRegistering = true
        if (!self.validateRegister()) {
          self.isRegistering = false
          return
        }
        self.pp.registerAccount(
          self.$root.$i18n.locale,
          self.email,
          self.password,
          self.$refs['checkboxTransfer'].checked ? JSON.parse(self.getPromptPaiCookies('Uuid')) : undefined,
          undefined,
          (result) => {
            if (result.status.code === 200) {
              self.messageOfActivateOnEmailDialog = result.status.text
              self.alertFromRegister = ''
              self.isRegistering = false
              self.isShowingActivateOnEmailDialog = true
            } else if (result.status.code === 403) {
              self.alertFromRegister = result.status.text
              self.isRegistering = false
            } else {
              self.alertFromRegister = result.status.text
              self.isRegistering = false
            }
          }
        )
      } else {
        self.isLoggingIn = true
        self.pp.login(
          self.$root.$i18n.locale,
          self.username,
          self.password,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          self.$refs['checkboxTransfer'].checked ? JSON.parse(self.getPromptPaiCookies('Uuid')) : undefined,
          undefined,
          self.afterLogin
        )
        window.gtag('event', 'login', { method: 'Promptpai' })
      }
    },
    afterLogin (result) {
      var self = this
      if (result.status.code === 200) {
        self.alertFromLogin = ''
        var userProfile = result.data
        if (userProfile.longdousertoken !== '' && userProfile.longdousertoken !== null && userProfile.longdousertoken !== undefined && userProfile.uid !== '' && userProfile.uid !== null && userProfile.uid !== undefined) {
          self.setPromptPaiCookies('isAuthenticated', JSON.stringify(true), Infinity, '/')
          self.setPromptPaiCookies('UserProfile', JSON.stringify(userProfile), Infinity, '/')
          self.initialApp()
          self.registerFcmToken()
        } else {
          self.setPromptPaiCookies('isAuthenticated', JSON.stringify(false), Infinity, '/')
        }
        self.isLoggingIn = false
      } else if (result.status.code === 403) {
        if (result.status.error_code === 'policy_not_accepted') {
          self.alertFromLogin = self.$root.$t('Login.policyNotAcceptedFromSocialLogin')
          setTimeout(() => {
            self.shakeRegisterButton = true
            setTimeout(() => {
              self.shakeRegisterButton = false
            }, 800)
          }, 300)
        } else {
          self.alertFromLogin = result.status.text
        }
        self.setPromptPaiCookies('isAuthenticated', JSON.stringify(false), Infinity, '/')
        self.isLoggingIn = false
      } else {
        self.alertFromLogin = result.status.text
        self.setPromptPaiCookies('isAuthenticated', JSON.stringify(false), Infinity, '/')
        self.isLoggingIn = false
      }
    },
    registerFcmToken () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'Android application' || userAgent === 'iOS application') {
        window.onTokenRefresh = (refreshedToken) => {
          // console.log('onTokenRefresh (after login) => ', refreshedToken)
          self.isRegistingFcmToken = true
          self.refreshFcmToken(refreshedToken, () => {
            self.$router.replace(self.$route.path)
            self.$router.go(0)
          })
        }
        window.location.href = 'https://native.getFcmToken'
      } else {
        if (!window.firebase.messaging.isSupported()) {
          self.$router.replace(self.$route.path)
          self.$router.go(0)
          return
        }
        self.isShowingAllowNotiPermissionDialog = true
        new Promise((resolve, reject) => {
          if (Notification.permission === 'granted') {
            resolve(true)
          } else if (Notification.permission === 'denied') {
            resolve(false)
          } else {
            self.allowPermissionNotiDialogCallback = resolve
          }
        }).then((r) => {
          if (!r) {
            self.$router.replace(self.$route.path)
            self.$router.go(0)
            return
          }
          self.isShowingAllowNotiPermissionDialog = false
          self.isRequestingPermission = true
          window.messaging.requestPermission().then(() => {
            // console.log('Notification permission granted')
            self.isRequestingPermission = false
            self.isRegistingFcmToken = true
            window.messaging.getToken().then(currentToken => {
              if (currentToken) {
                // var userProfile = {}
                // var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
                // var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
                // if (isAuthenticated) {
                //   userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
                //   uuid = undefined
                // }
                // self.pp.registerFcmToken(
                //   'name' in userProfile ? userProfile.name : undefined,
                //   'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
                //   isAuthenticated ? undefined : uuid,
                //   currentToken,
                //   JSON.parse(self.getPromptPaiCookies('deviceId')),
                //   undefined,
                //   (result) => {
                //     if (result.status.code === 200) {
                //     } else if (result.status.code === 403) {
                //     } else {
                //     }
                //     self.$router.replace(self.$route.path)
                //     self.$router.go(0)
                //   }
                // )
                self.refreshFcmToken(currentToken, () => {
                  self.$router.replace(self.$route.path)
                  self.$router.go(0)
                })
              } else {
                // console.log('No Instance ID token available. Request permission to generate one')
                self.$router.replace(self.$route.path)
                self.$router.go(0)
              }
            }).catch(err => {
              console.log('An error occurred while retrieving token', err)
              self.$router.replace(self.$route.path)
              self.$router.go(0)
            })
          }).catch(err => {
            console.log('Unable to get permission to notify', err)
            self.$router.replace(self.$route.path)
            self.$router.go(0)
          })
        })
      }
    },
    facebookLogin () {
      var self = this
      self.isLoggingIn = true

      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'iOS application') {
        window.getFacebookSuccess = (socialToken, uid, email) => {
          self.pp.login(
            self.$root.$i18n.locale,
            undefined,
            undefined,
            undefined,
            undefined,
            'fb',
            uid,
            socialToken,
            email,
            self.$refs['checkboxTransfer'].checked ? JSON.parse(self.getPromptPaiCookies('Uuid')) : undefined,
            undefined,
            self.afterLogin
          )
          window.gtag('event', 'login', { method: 'Facebook' })
          window.location.href = 'https://native.logoutfacebook'
        }
        window.getFacebookFail = (errorMessage, errorCode) => {
          self.afterLogin({
            status: {
              code: errorCode,
              text: errorMessage
            }
          })
        }
        window.location.href = 'https://native.loginfacebook'
      } else if (userAgent === 'Android application') {
        window.getFacebookSuccess = (socialToken, uid, email) => {
          self.pp.login(
            self.$root.$i18n.locale,
            undefined,
            undefined,
            undefined,
            undefined,
            'fb',
            uid,
            socialToken,
            email,
            self.$refs['checkboxTransfer'].checked ? JSON.parse(self.getPromptPaiCookies('Uuid')) : undefined,
            undefined,
            self.afterLogin
          )
          window.gtag('event', 'login', { method: 'Facebook' })
          Android.logoutFacebook()
        }
        window.getFacebookFail = (errorMessage) => {
          self.afterLogin({
            status: {
              code: null, // errorCode
              text: errorMessage
            }
          })
        }
        window.cancelFacebookLogin = () => {
          self.isLoggingIn = false
        }
        Android.loginFacebook()
      } else {
        self.isLoggingIn = true
        window.FB.login((response) => {
          if (response.authResponse) {
            var uid = response.authResponse.userID
            var socialToken = response.authResponse.accessToken
            window.FB.api('/me?fields=email', (result) => {
              self.pp.login(
                self.$root.$i18n.locale,
                undefined,
                undefined,
                undefined,
                undefined,
                'fb',
                uid,
                socialToken,
                result.email,
                self.$refs['checkboxTransfer'].checked ? JSON.parse(self.getPromptPaiCookies('Uuid')) : undefined,
                undefined,
                self.afterLogin
              )
              window.gtag('event', 'login', { method: 'Facebook' })
            })
          }
        }, {scope: 'email,public_profile', return_scopes: true})
      }
    },
    initApple (d, s, id) {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      // init for web only
      if (userAgent === 'iOS application' || userAgent === 'Android application') {
        return false
      }
      var js
      var fjs = d.getElementsByTagName('head')[0]
      if (d.getElementById(id)) {
        d.getElementById(id).remove()
      }
      js = d.createElement(s); js.id = id
      js.addEventListener('load', function () {
        // Listen for authorization success
        document.addEventListener('AppleIDSignInOnSuccess', (data) => {
          self.isLoggingIn = true
          const userInfo = self.util.parseJwt(data.detail.authorization.id_token)
          self.pp.login(
            self.$root.$i18n.locale,
            undefined,
            undefined,
            undefined,
            undefined,
            'apple',
            userInfo.sub,
            data.detail.authorization.code,
            userInfo.email,
            self.$refs['checkboxTransfer'].checked ? JSON.parse(self.getPromptPaiCookies('Uuid')) : undefined,
            undefined,
            self.afterLogin
          )
          window.gtag('event', 'login', { method: 'Apple' })
        })

        // Listen for authorization failures
        document.addEventListener('AppleIDSignInOnFailure', (error) => {
          // handle error.
          console.log(error)
        })

        // init
        window.AppleID.auth.init({
          clientId: 'com.promptpai',
          scope: 'name email',
          redirectURI: process.env.PROMPTPAI_URL + '/',
          state: '',
          nonce: '',
          usePopup: true // or false defaults to false
        })
      })
      js.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
      fjs.append(js)
    },
    appleLogin () {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'iOS application') {
        window.getAppleSuccess = (socialToken, uid, email, name) => {
          self.isLoggingIn = true
          self.pp.login(
            self.$root.$i18n.locale,
            undefined,
            undefined,
            undefined,
            undefined,
            'apple',
            uid,
            socialToken,
            email,
            self.$refs['checkboxTransfer'].checked ? JSON.parse(self.getPromptPaiCookies('Uuid')) : undefined,
            undefined,
            self.afterLogin
          )
          window.gtag('event', 'login', { method: 'Apple' })
        }
        window.getAppleFail = (errorMessage, errorCode) => {
          self.afterLogin({
            status: {
              code: errorCode,
              text: errorMessage
            }
          })
        }
        window.location.href = 'https://native.loginapple'
      } else {
        window.AppleID.auth.signIn()
      }
    },
    lineLogin () {
      // var self = this
      // var type = 'code'
      // var id = '1566443573'
      // var url = window.location.origin + '/linelogin'
      // var state = new Date().getTime()
      // var scope = 'openid%20profile%20email'
      // var name = 'Promptpai Login with Line'
      // var width = 320
      // var height = 480
      // var left = (self.windowWidth - width) / 2
      // var top = (self.windowHeight - height) / 2
      // window.open('https://access.line.me/oauth2/v2.1/authorize?response_type=' + type + '&client_id=' + id + '&redirect_uri=' + url + '&state=' + state + '&scope=' + scope + '&nonce=09876xyz', name, 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top)
    },
    googleLogin () {
    },
    closeActivateOnEmailDialog () {
      var self = this
      self.clickCloseButton()
    }
  },
  watch: {
    isRegisterMode () {
      var self = this
      self.$nextTick(() => {
        if (self.isRegisterMode) {
          self.isShowAcceptPdpa = true
        } else {
          self.isShowAcceptPdpa = false
        }
        self.email = ''
        self.username = ''
        self.password = ''
        self.confirmPassword = ''
        self.alertFromLogin = ''
        self.alertFromRegister = ''
      })
    }
  }
}
</script>

<style scoped>
  .login {
    height: fit-content;
    width: 320px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .body {
    padding: 16px;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  button.alternative-login-button {
    width: 100%;
    border-radius: 4px;
    border: none;
    margin: 8px 0px;
    padding: 6px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: rgb(255, 255, 255);
    color: rgb(74, 74, 74);
    border: 1px solid rgb(227, 227, 227);
  }

  button.alternative-login-button > img {
    height: 24px;
    width: 24px;
    margin-right: 20px;
    border-radius: 3px;
    overflow: hidden;
  }

  button.alternative-login-button > label {
    cursor: pointer;
    font-family: 'Prompt';
  }

  button.alternative-login-button.facebook {
    margin-top: 0px;
  }

  .alternative-label {
    color: rgb(120, 120, 120);
    margin: 8px 0px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  input[type="email"],
  input[type="text"],
  input[type="password"] {
    width: 100%;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(120, 120, 120);
    border-radius: 4px;
    margin: 0px 0px 8px 0px;
    padding: 10px;
    color: rgb(74, 74, 74);
    box-sizing: border-box;
    height: 40px;
  }

  ::-webkit-input-placeholder {
    color: rgb(120, 120, 120);
    line-height: 1.75;
  }

  .forgot-password {
    padding: 0px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    margin-left: auto;
    margin-right: 0px;
    flex: 0 0 auto;
    align-self: flex-start;
  }

  .forgot-password:hover {
    color: rgb(59, 144, 255);
  }

  .pp-checkbox {
    display: block;
    position: relative;
    padding-left: 21px;
    padding-right: 16px;
    margin-bottom: 0px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .pp-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .pp-checkbox .checkmark {
    position: absolute;
    top: 3px;
    left: 0;
    height: 15px;
    width: 15px;
    border: 1px solid rgb(59, 144, 255);
    box-sizing: border-box;
    border-radius: 3px;
  }
  .pp-checkbox input:checked ~ .checkmark:after {
    opacity: 1;
    -webkit-transform: rotate(45deg) scale(1);
    -ms-transform: rotate(45deg) scale(1);
    transform: rotate(45deg) scale(1);
  }
  .pp-checkbox .checkmark:after {
    transition: opacity 0.3s ease 0s, -webkit-transform 0.3s ease 0s, -ms-transform 0.3s ease 0s, transform 0.3s ease 0s;
    content: "";
    position: absolute;
    display: block;
    left: 4px;
    top: 1px;
    width: 3px;
    height: 7px;
    border: solid rgb(59, 144, 255);
    border-width: 0 2px 2px 0;
    opacity: 0;
    -webkit-transform: scale(0.01);
    -ms-transform: scale(0.01);
    transform: scale(0.01);
  }

  .submit-btn {
    width: 100%;
    padding: 6px;
    background: rgb(59, 144, 255);
    border-radius: 4px;
    border: none;
    color: rgb(255, 255, 255);
    margin: 8px 0px 8px 0px;
    cursor: pointer;
    line-height: 1.75;
    font-family: 'Prompt';
  }

  .goto-mode {
    border-radius: 4px;
    color: rgb(59, 144, 255);
    border: 1px solid rgb(59, 144, 255);
    margin: 8px auto 0px auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    width: 100%;
    box-sizing: border-box;
    line-height: 1.75;
    font-family: 'Prompt';
  }

  .login-alert,
  .register-alert {
    color: rgb(220, 20, 60);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .noti-permission-dialog,
  .activate-on-email-dialog {
    padding: 16px;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  .noti-permission-dialog > .text,
  .activate-on-email-dialog > .text {
    margin: 16px 0px 24px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    line-height: 1.75;
    text-align: center;
  }

  .noti-permission-dialog > .button-container,
  .activate-on-email-dialog > .button-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .noti-permission-dialog > .button-container > button {
    width: calc((100% - 16px) / 2);
    padding: 6px;
    background: rgb(59, 144, 255);
    border-radius: 4px;
    border: none;
    color: rgb(255, 255, 255);
    margin: 0px;
    cursor: pointer;
    font-family: Prompt;
  }

  .noti-permission-dialog > .button-container > button.outline {
    background: rgb(255, 255, 255);
    border: 1px solid rgb(59, 144, 255);
    color: rgb(59, 144, 255);
  }

  .loading-animation-container {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.6);
  }

  .activated-notice {
    color: rgb(53, 172, 25);
    text-align: center;
    padding-bottom: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue